<template>
  <div class="whole">
    <div class="title" style="font-size: 30px">学区地图查询</div>
    <div class="mr-right">
      <el-select
        v-model="location_name"
        filterable
        remote
        placeholder="搜索学区"
        :remote-method="handleSelectChangeLine"
      >
        <el-option
          v-for="item in schools"
          :key="item.id"
          :label="item.location_name"
          :value="item.location_name"
        >
        </el-option>
      </el-select>
    </div>
    <el-button type="primary" @click="search()">查询</el-button>
  </div>
</template>
<script>
export default {
  name: "secondSubwaySale",
  data() {
    return {
      location_name: "",
      schools: [],
      school: {},
    };
  },
  async created() {
    await this.getAllSchools();
  },
  computed: {},
  methods: {
    async getAllSchools(query) {
      try {
        let res = await this.$axios.post(
          this.$url_prefix + "searhSchoolByName",
          { search: query || "" }
        );
        this.schools = res.data.searchList;
      } catch (error) {
        console.log(error);
      }
    },
    async handleSelectChangeLine(query) {
      await this.getAllSchools(query);
    },
    async search() {
      try {
        for (let index = 0; index < this.schools.length; index++) {
          const element = this.schools[index];
          if (element.location_name === this.location_name) {
            this.school = element;
            break;
          }
        }
        if (this.school.hasOwnProperty("id")) {
          console.log("选择学区", this.school.location_name);
          let item = {
            type: "单个学区地图",
            area: this.school,
          };
          this.$router.push({
            name: "location-image",
            params: item,
          });
        } else {
          this.$message.error("请选择学区");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.whole {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}
.table {
  margin-top: 4px;
  width: 100%;
}
.title {
  padding-bottom: 10px;
  font-weight: 700;
}
.mr-right {
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/page/secHandSchool.vue